export const config = {
  api: {
    // Empty string = same-origin / Vite proxy in dev
    baseUrl: import.meta.env.VITE_API_BASE ?? '',
  },
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    region: import.meta.env.VITE_COGNITO_REGION || 'ap-southeast-3',
    domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
    redirectSignIn: import.meta.env.VITE_REDIRECT_SIGN_IN || 'http://localhost:3008',
    redirectSignOut: import.meta.env.VITE_REDIRECT_SIGN_OUT || 'http://localhost:3008',
  },
} as const
